
import React from 'react';
import { AlertCircle } from 'lucide-react';

interface PasswordErrorProps {
  errorMessage: string;
  remainingAttempts: number;
}

const PasswordError = ({ errorMessage, remainingAttempts }: PasswordErrorProps) => {
  if (!errorMessage) return null;
  
  return (
    <div className="flex items-center gap-2 text-red-400 mt-2">
      <AlertCircle className="h-4 w-4" />
      <span>
        {errorMessage} ({remainingAttempts} {remainingAttempts === 1 ? 'attempt' : 'attempts'} remaining)
      </span>
    </div>
  );
};

export default PasswordError;
